import React from 'react';

function ArrowDownIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
			<path d="M7.43863 4.84079L12 1.16208L10.5636 0.00366639L6.00227 3.68238L1.43635 -4.11464e-07L-5.68242e-08 1.15841L6.00326 6L7.43962 4.84159L7.43863 4.84079Z" fill="currentColor"/>
		</svg>
	);
}
export default ArrowDownIcon;
